import { connect } from 'react-redux';
import AccreditationsList from "./AccreditationsList";
import {
    getRejectedByApplicantsAccreditations,
    getAccreditationsList,
    loadingAccreditationList,
    setStartAccreditation,
    getAccreditationsPerCountryData,
    getAccreditationsCountryFilter,
    fetchGetAccreditationsPerCountryRejectedByApplicants,
    onUpdateAccreditationsCountryFilterRejectedByApplicants,
    clearAccreditationsCountryFilter,
    clearAccreditationsDomainFilter,
    onFetchGetAccreditationsPerDomainRejectedByApplicants,
    onUpdateAccreditationsDomainFilterRejectedByApplicants,
    getAccreditationsPerDomainData, getAccreditationsDomainFilter, getAccreditationRequestsPerContinentData,
} from '../../../reducers/accreditation/accreditations';
import { getTranslation } from "../../../reducers/common/localization";
import {getCurrentGroup, getGroupsNumberForSubRole} from "../../../reducers/account/role";
import { MODAL_REMOVE_ACCREDITATION, showModal } from "../../../reducers/common/activeModal";
import { isOrgBava } from '../../../reducers/organization/organization';
import {getLocationData} from '../../../reducers/common/location';

const mapStateToProps = state => {
    return {
        noDataLabelPath: 'accreditation_list.no_data_to_review_message',
        showHeader: false,
        loading: loadingAccreditationList(state),
        data: getAccreditationsList(state),
        group: getCurrentGroup(state),
        redirectPath: 'review-accreditation/applicant',
        translation: getTranslation(state),
        canRemoveAccreditations: true,
        groupsNumber: getGroupsNumberForSubRole(state),
        isOrgBava: isOrgBava(state),
        requestsPerCountry: getAccreditationsPerCountryData(state),
        showCountryFilter: true,
        countryFilter: getAccreditationsCountryFilter(state),
        requestsPerDomain: getAccreditationsPerDomainData(state),
        domainFilter: getAccreditationsDomainFilter(state),
        requestsPerContinent: getAccreditationRequestsPerContinentData(state),
        locationData: getLocationData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoadAccreditations: (group, page) => dispatch(getRejectedByApplicantsAccreditations(group, page)),
        onStartValidation: (id) => {
            dispatch(setStartAccreditation(id));
        },
        onRemoveAccreditation: () => dispatch(showModal({ modalKey: MODAL_REMOVE_ACCREDITATION })),
        onLoadARsPerCountry: (groupId) => dispatch(fetchGetAccreditationsPerCountryRejectedByApplicants(groupId)),
        onUpdateCountryFilter: (countryFilter) => dispatch(onUpdateAccreditationsCountryFilterRejectedByApplicants(countryFilter)),
        onClearCountryFilter: () => dispatch(clearAccreditationsCountryFilter()),
        onLoadARsPerDomain: (groupId) => dispatch(onFetchGetAccreditationsPerDomainRejectedByApplicants(groupId)),
        onUpdateDomainFilter: (domain) => dispatch(onUpdateAccreditationsDomainFilterRejectedByApplicants(domain)),
        onClearDomainFilter: () => dispatch(clearAccreditationsDomainFilter()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccreditationsList);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationsList/RejectedAccreditationsByApplicantsList.container.js